import React from 'react';
import { Link } from 'react-router';

function Tools({
  count,
  deleteSuperhosts
}) {
  return (
    <div className="admin_list">
      <h5>Superhosts (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/superhosts/new">Add Superhost</Link>
      <a className="button_delete" onClick={deleteSuperhosts}>Delete</a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/Superhosts/Toolbar/Tools.jsx